import Autocomplete from '../Autocomplete/Autocomplete';
import PatientItem from './PatientItem';

export default function PatientAutocomplete(props) {
	return (
		<Autocomplete
			{...props}
			itemTemplate={props => <PatientItem {...props} user={props.item} />}
		/>
	);
}
